/**
 * @generated SignedSource<<9500f9b1a14e801ed7aac98b086d50b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SessionStatusEnum = "ACTIVE" | "AWAITING_PAYMENT" | "CANCELLED" | "CANCELLED_LATE" | "COMPLETED" | "EMPLOYEE_NO_SHOW" | "NO_SHOW" | "PAYMENT_EXPIRED" | "PROFESSIONAL_NO_SHOW" | "SCHEDULED";
export type ModifySessionMutation$variables = {
  date?: string | null | undefined;
  sessionId: string;
  status: SessionStatusEnum;
};
export type ModifySessionMutation$data = {
  readonly adminUpdateSession: {
    readonly __typename: "AdminSessionUpdated";
    readonly sessionId: string;
    readonly success: boolean;
  } | {
    readonly __typename: "ForbiddenError";
    readonly reason: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type ModifySessionMutation = {
  response: ModifySessionMutation$data;
  variables: ModifySessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      },
      {
        "kind": "Variable",
        "name": "sessionId",
        "variableName": "sessionId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "adminUpdateSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          }
        ],
        "type": "AdminSessionUpdated",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          }
        ],
        "type": "ForbiddenError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifySessionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ModifySessionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a8ce175e5c3e7dbee92e197f37ecf6de",
    "id": null,
    "metadata": {},
    "name": "ModifySessionMutation",
    "operationKind": "mutation",
    "text": "mutation ModifySessionMutation(\n  $sessionId: ID!\n  $status: SessionStatusEnum!\n  $date: DateTime\n) {\n  adminUpdateSession(sessionId: $sessionId, status: $status, date: $date) {\n    __typename\n    ... on AdminSessionUpdated {\n      success\n      sessionId\n    }\n    ... on ForbiddenError {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "795f698647a3e80703e8fead7f70d010";

export default node;
